export const BASE_API_URL = "https://gateway-dev.21jobwork.com"
